// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/icomoon.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/icomoon.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html {
  background: #F5F5F5;
  padding: 0;
  margin: 0;
  font-family: 'Inter';
  color: var(--Text-Default, var(--grayscale-860, #242424));
}

body {
  --color-interactive-primary-hover: #1773b0;
  --color-border-container: #e2e2e2;
}

/* prevent whitespace at bottom of page due to hidden elements */
#root {
  position: fixed;
  width: 100%;
  min-height: 100%;
}

/* shared classes */
.aims-btn-reset {
  font-size: inherit;
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  cursor: pointer;
  font-family: 'Inter';
}

.aims-btn-reset:focus-visible {
  outline: 3px solid #2A7FB8;
}

.aims-btn-reset.aims-outline-inner:focus-visible {
  outline-offset: -3px;
}

.aims-btn-reset.aims-white-focus-ring:focus-visible {
  outline: 3px solid #fff;
}

.aims-container {
  padding-left: 0;
  padding-right: 0;
}

.aims-header {
  background-color: #002B51;
  color: #fff;
  padding: 0 16px;
}

.aims-user-col {
  justify-content: flex-end;
  align-items: center;
  display: flex;
  ;
}

.aims-heading-logo-mobile {
  display: none;
}

.aims-menu-btn {
  display: flex;
  align-items: center;
  margin-right: 12px;
  position: relative;
  width: 20px;
}

.aims-menu-icon {
  width: 18px;
}

.aims-menu-close-icon {
  position: relative;
  top: 2px;
  color: #fff;
  font-size: 16px;
}

.aims-ms-logo {
  font-family: 'icomoon';
  font-weight: normal;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  font-size: 22px;
  margin-top: 9px;
  margin-right: 16px;
  position: relative;
  top: 2px;
}

.aims-ms-logo::before {
  /* transform: rotate(.05deg); */
  display: inline-block;
  content: "\\e606";
  /* margin-left: 4px;
  padding-bottom: 0.3px; */
}

.aims-main-heading {
  /* Header/Section */
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  position: relative;
  bottom: px;
  line-height: 20px;
  height: 20px;
  letter-spacing: 0.1px;
  border-left: 1px solid #E2E2E2;
  padding-left: 16px;
  margin: 14px 0;
}

.aims-main-heading button {
  line-height: 1;
}

.aims-ai-icon {
  position: relative;
  right: 3px;
  top: 3px;
  font-size: 17px;
}

.aims-user-btn {
  justify-content: end;
  align-items: center;
  color: white;
  padding-right: 0;
}

.aims-user-icon {
  background: #E9F2F9;
  height: 24px;
  width: 24px;
  border-radius: 12px;
  color: #002B51;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  margin-right: 8px;
}

.aims-user-name {
  color: #FFF;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.aims-user-caret {
  position: relative;
  top: 3px;
  left: 2px;
}

.aims-header-new-btn {
  display: none;
}

.aims-heading-mobile-spacer {
  display: none;
}

@media only screen and (max-width: 768px) {
  .aims-heading-mobile-spacer {
    display: flex;
  }

  .aims-ms-logo {
    display: none;
    background: red;
  }

  .aims-heading-logo {
    display: none;
  }

  .aims-heading-logo-mobile {
    display: flex;
    justify-content: center;
  }

  .aims-main-heading {
    /* Header/Section */
    padding-left: 8px;
    border-left: none;
  }

  .aims-user-name {
    display: none;
  }

  .aims-menu-btn {
    display: none;
  }
}

@media only screen and (max-width: 500px) {
  .aims-menu-btn {
    display: block;
  }

  .aims-heading-logo {
    display: none;
  }

  .aims-heading-logo-mobile {
    display: flex;
  }

  .aims-user-name,
  .aims-user-caret {
    display: none;
  }

  .aims-user-icon {
    margin-right: 0;
    display: none;
  }

  .aims-header-new-btn {
    display: block;
  }
}

.aims-wrap {
  display: flex;
  align-items: stretch;
}

/* main */
.aims-main-wrap {
  display: flex;
  justify-content: center;
  flex-basis: 100%;
  flex-shrink: 1;
}

.aims-main {
  max-width: 1069px;
  width: 100%;
  min-height: calc(100vh - 50px);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  /* border: 1px solid pink; */
}

.aims-main.aims-main--initial {
  justify-content: space-between;
}

/* chat input area */
.aims-task-select {
  position: relative;
  top: 2px;
}

.aims-upload:hover img {
  filter: brightness(.85);
}

.aims-p {
  margin-bottom: 8px !important;
  margin-top: 0;
}

.aims-chat-legal {
  color: #666;
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  line-height: 16px;
  /* 133.333% */
  letter-spacing: 0.2px;
  margin-bottom: 24px;
}

/* chat bubble */
.aims-caveats {
  color: #666;
  display: flex;
  justify-content: flex-end;
  font-size: 12px;
  gap: 4px;
  padding-top: 8px;
  border-top: 1px solid #E2E2E2;
}

.aims-caveat-info {
  position: relative;
  top: 2px
}

.aims-feedback-footer {
  padding-top: 8px;
  border-top: 1px solid #E2E2E2;
  display: flex;
  justify-content: space-between;
}

.aims-feedback-footer__caveats {
  color: #666;
  display: flex;
  font-size: 12px;
  gap: 4px;
}

.aims-feedback-actions {
  position: relative;
  top: 4px;
}

.aims-feedback-icon {
  font-size: 14px;
  margin-right: 8px;
}

/* .aims-feedback-dislike-icon {
  position: relative;
} */

@font-face {
  font-family: 'icomoon';
  font-style: normal;
  font-weight: normal;

  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

.aims-chat-and-input-wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100vh - 48px);
}

.aims-chat-outer {
  height: calc(100vh - 177px);
  min-height: 0;
  flex-shrink: 999;
  padding-bottom: 8px;
  align-content: center;
  /* justify-content: flex-end; */
  display: flex;
  flex-direction: column;
  align-items: stretch;
  display: flex;
  /* border: 3px solid purple;
  box-sizing: border-box; */
}

.aims-chat-outer--initial {
  justify-content: center;
}

@media only screen and (max-width: 500px) {
  .aims-chat-outer--initial {
    justify-content: center;
  }
}

.aims-input-outer {
  /* border: 3px solid green; */
  box-sizing: border-box;
  flex-shrink: 0;
  margin-left: 16px;
  margin-right: 16px;
}

.aims-chat-inner {
  overflow-y: auto;
  padding-left: 16px;
  padding-right: 16px;
}

.aims-chat-grid {
  margin-left: 16px;
  margin-right: 16px;
}


.chat-inner:focus-visible {
  outline: 3px solid #2A7FB8;
}

.chat-input-wrapper {
  border-top: 1px solid #ccc;
  padding-top: 24px;
  display: flex;
}

.ask-btn-wrapper {
  /* border: 1px solid red; */
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-bottom: 4px;
  padding-left: 8px;
  position: relative;
  bottom: 15px;
}

.text-input-wrapper {
  flex-grow: 1;
  margin-right: 16px;
}

.aims-file-input {
  display: none;
}

.vanilla-text-input {
  width: 100%;
  font-family: 'Inter';
  padding: 5px;
}

.chat-bubble {
  padding: 16px;
  margin-bottom: 16px;
}

.chat-bubble--bot {
  background: #e9f2f7;
}

.chat-bubble--human {
  background: #f5f5f5;
}

.aims-followup {
  margin-top: 16px;
}

.aims-followup-ul {
  padding-left: 16px;
  margin-top: 16px;
}

.aims-followup-li {
  margin-bottom: 8px;
}

.aims-sources-ul {
  padding-left: 16px;
  margin-top: 16px;
}

.aims-sources-li {
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
}

.aims-meeting-summary-ul {
  padding-bottom: 24px;
  border-bottom: 1px solid #E2E2E2;
}

.aims-meeting-summary-ul li {
  list-style-type: disc;
  margin-bottom: 16px;
}

.aims-chat-message {
  margin-bottom: 16px;
}

.aims-upload-icon {
  color: var(--color-interactive-primary-default);
  background: none;
  position: relative;
  top: 4px;
  font-size: 16px;
  ;
}

.aims-upload-icon:hover {
  color: var(--color-interactive-primary-hover);
  background: none;
}

.campy-chat-area {
  display: none;
}

/* loader */
:root {
  --loader-color: rgb(17, 115, 176);
}

.loader {
  position: relative;
  left: -9999px;
  margin-left: 40px;
  margin-bottom: 40px;
  margin-top: 40px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: var(--loader-color);
  color: var(--loader-color);
  box-shadow: 9984px 0 0 0 var(--loader-color), 9999px 0 0 0 var(--loader-color), 10014px 0 0 0 var(--loader-color);
  animation: dot-typing 1.5s infinite linear;
}

@keyframes dot-typing {
  0% {
    box-shadow: 9984px 0 0 0 var(--loader-color), 9999px 0 0 0 var(--loader-color), 10014px 0 0 0 var(--loader-color);
  }

  16.667% {
    box-shadow: 9984px -10px 0 0 var(--loader-color), 9999px 0 0 0 var(--loader-color), 10014px 0 0 0 var(--loader-color);
  }

  33.333% {
    box-shadow: 9984px 0 0 0 var(--loader-color), 9999px 0 0 0 var(--loader-color), 10014px 0 0 0 var(--loader-color);
  }

  50% {
    box-shadow: 9984px 0 0 0 var(--loader-color), 9999px -10px 0 0 var(--loader-color), 10014px 0 0 0 var(--loader-color);
  }

  66.667% {
    box-shadow: 9984px 0 0 0 var(--loader-color), 9999px 0 0 0 var(--loader-color), 10014px 0 0 0 var(--loader-color);
  }

  83.333% {
    box-shadow: 9984px 0 0 0 var(--loader-color), 9999px 0 0 0 var(--loader-color), 10014px -10px 0 0 var(--loader-color);
  }

  100% {
    box-shadow: 9984px 0 0 0 var(--loader-color), 9999px 0 0 0 var(--loader-color), 10014px 0 0 0 var(--loader-color);
  }
}

ul {
  margin-top: 0;
  margin-bottom: 0;
}

.color-interactive {
  color: #1773b0;
}

.color-gray {
  color: #666;
}

label {
  color: #666;
  font-size: 12px;
  margin-bottom: 4px;
}

ul {
  padding: 0;
}

li {
  list-style: none;
}

.aims-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;EAEE,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA,gEAAgE;AAChE;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,UAAU;EACV,SAAS;EACT,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;;AAEf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;EAChB;0BACwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;;EAEnB;8DACiD;AACnD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;EACb;2BACyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;;AAGA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,eAAe;;AAEjB;;AAEA;EACE,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,WAAW;AACX;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,0BAA0B;EAC1B,iHAAiH;EACjH,0CAA0C;AAC5C;;AAEA;EACE;IACE,iHAAiH;EACnH;;EAEA;IACE,qHAAqH;EACvH;;EAEA;IACE,iHAAiH;EACnH;;EAEA;IACE,qHAAqH;EACvH;;EAEA;IACE,iHAAiH;EACnH;;EAEA;IACE,qHAAqH;EACvH;;EAEA;IACE,iHAAiH;EACnH;AACF;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":["body,\nhtml {\n  background: #F5F5F5;\n  padding: 0;\n  margin: 0;\n  font-family: 'Inter';\n  color: var(--Text-Default, var(--grayscale-860, #242424));\n}\n\nbody {\n  --color-interactive-primary-hover: #1773b0;\n  --color-border-container: #e2e2e2;\n}\n\n/* prevent whitespace at bottom of page due to hidden elements */\n#root {\n  position: fixed;\n  width: 100%;\n  min-height: 100%;\n}\n\n/* shared classes */\n.aims-btn-reset {\n  font-size: inherit;\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  cursor: pointer;\n  font-family: 'Inter';\n}\n\n.aims-btn-reset:focus-visible {\n  outline: 3px solid #2A7FB8;\n}\n\n.aims-btn-reset.aims-outline-inner:focus-visible {\n  outline-offset: -3px;\n}\n\n.aims-btn-reset.aims-white-focus-ring:focus-visible {\n  outline: 3px solid #fff;\n}\n\n.aims-container {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.aims-header {\n  background-color: #002B51;\n  color: #fff;\n  padding: 0 16px;\n}\n\n.aims-user-col {\n  justify-content: flex-end;\n  align-items: center;\n  display: flex;\n  ;\n}\n\n.aims-heading-logo-mobile {\n  display: none;\n}\n\n.aims-menu-btn {\n  display: flex;\n  align-items: center;\n  margin-right: 12px;\n  position: relative;\n  width: 20px;\n}\n\n.aims-menu-icon {\n  width: 18px;\n}\n\n.aims-menu-close-icon {\n  position: relative;\n  top: 2px;\n  color: #fff;\n  font-size: 16px;\n}\n\n.aims-ms-logo {\n  font-family: 'icomoon';\n  font-weight: normal;\n  font-style: normal;\n  -webkit-font-smoothing: antialiased;\n  font-size: 22px;\n  margin-top: 9px;\n  margin-right: 16px;\n  position: relative;\n  top: 2px;\n}\n\n.aims-ms-logo::before {\n  /* transform: rotate(.05deg); */\n  display: inline-block;\n  content: \"\\e606\";\n  /* margin-left: 4px;\n  padding-bottom: 0.3px; */\n}\n\n.aims-main-heading {\n  /* Header/Section */\n  font-family: Inter;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  position: relative;\n  bottom: px;\n  line-height: 20px;\n  height: 20px;\n  letter-spacing: 0.1px;\n  border-left: 1px solid #E2E2E2;\n  padding-left: 16px;\n  margin: 14px 0;\n}\n\n.aims-main-heading button {\n  line-height: 1;\n}\n\n.aims-ai-icon {\n  position: relative;\n  right: 3px;\n  top: 3px;\n  font-size: 17px;\n}\n\n.aims-user-btn {\n  justify-content: end;\n  align-items: center;\n  color: white;\n  padding-right: 0;\n}\n\n.aims-user-icon {\n  background: #E9F2F9;\n  height: 24px;\n  width: 24px;\n  border-radius: 12px;\n  color: #002B51;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  line-height: 1;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  margin-right: 8px;\n}\n\n.aims-user-name {\n  color: #FFF;\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.aims-user-caret {\n  position: relative;\n  top: 3px;\n  left: 2px;\n}\n\n.aims-header-new-btn {\n  display: none;\n}\n\n.aims-heading-mobile-spacer {\n  display: none;\n}\n\n@media only screen and (max-width: 768px) {\n  .aims-heading-mobile-spacer {\n    display: flex;\n  }\n\n  .aims-ms-logo {\n    display: none;\n    background: red;\n  }\n\n  .aims-heading-logo {\n    display: none;\n  }\n\n  .aims-heading-logo-mobile {\n    display: flex;\n    justify-content: center;\n  }\n\n  .aims-main-heading {\n    /* Header/Section */\n    padding-left: 8px;\n    border-left: none;\n  }\n\n  .aims-user-name {\n    display: none;\n  }\n\n  .aims-menu-btn {\n    display: none;\n  }\n}\n\n@media only screen and (max-width: 500px) {\n  .aims-menu-btn {\n    display: block;\n  }\n\n  .aims-heading-logo {\n    display: none;\n  }\n\n  .aims-heading-logo-mobile {\n    display: flex;\n  }\n\n  .aims-user-name,\n  .aims-user-caret {\n    display: none;\n  }\n\n  .aims-user-icon {\n    margin-right: 0;\n    display: none;\n  }\n\n  .aims-header-new-btn {\n    display: block;\n  }\n}\n\n.aims-wrap {\n  display: flex;\n  align-items: stretch;\n}\n\n/* main */\n.aims-main-wrap {\n  display: flex;\n  justify-content: center;\n  flex-basis: 100%;\n  flex-shrink: 1;\n}\n\n.aims-main {\n  max-width: 1069px;\n  width: 100%;\n  min-height: calc(100vh - 50px);\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  /* border: 1px solid pink; */\n}\n\n.aims-main.aims-main--initial {\n  justify-content: space-between;\n}\n\n/* chat input area */\n.aims-task-select {\n  position: relative;\n  top: 2px;\n}\n\n.aims-upload:hover img {\n  filter: brightness(.85);\n}\n\n.aims-p {\n  margin-bottom: 8px !important;\n  margin-top: 0;\n}\n\n.aims-chat-legal {\n  color: #666;\n  font-size: 12px;\n  font-style: italic;\n  font-weight: 400;\n  line-height: 16px;\n  /* 133.333% */\n  letter-spacing: 0.2px;\n  margin-bottom: 24px;\n}\n\n/* chat bubble */\n.aims-caveats {\n  color: #666;\n  display: flex;\n  justify-content: flex-end;\n  font-size: 12px;\n  gap: 4px;\n  padding-top: 8px;\n  border-top: 1px solid #E2E2E2;\n}\n\n.aims-caveat-info {\n  position: relative;\n  top: 2px\n}\n\n.aims-feedback-footer {\n  padding-top: 8px;\n  border-top: 1px solid #E2E2E2;\n  display: flex;\n  justify-content: space-between;\n}\n\n.aims-feedback-footer__caveats {\n  color: #666;\n  display: flex;\n  font-size: 12px;\n  gap: 4px;\n}\n\n.aims-feedback-actions {\n  position: relative;\n  top: 4px;\n}\n\n.aims-feedback-icon {\n  font-size: 14px;\n  margin-right: 8px;\n}\n\n/* .aims-feedback-dislike-icon {\n  position: relative;\n} */\n\n@font-face {\n  font-family: 'icomoon';\n  font-style: normal;\n  font-weight: normal;\n\n  src: url('../public/icomoon.woff') format('woff'),\n    url('../public/icomoon.ttf') format('truetype');\n}\n\n.aims-chat-and-input-wrap {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: calc(100vh - 48px);\n}\n\n.aims-chat-outer {\n  height: calc(100vh - 177px);\n  min-height: 0;\n  flex-shrink: 999;\n  padding-bottom: 8px;\n  align-content: center;\n  /* justify-content: flex-end; */\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  display: flex;\n  /* border: 3px solid purple;\n  box-sizing: border-box; */\n}\n\n.aims-chat-outer--initial {\n  justify-content: center;\n}\n\n@media only screen and (max-width: 500px) {\n  .aims-chat-outer--initial {\n    justify-content: center;\n  }\n}\n\n.aims-input-outer {\n  /* border: 3px solid green; */\n  box-sizing: border-box;\n  flex-shrink: 0;\n  margin-left: 16px;\n  margin-right: 16px;\n}\n\n.aims-chat-inner {\n  overflow-y: auto;\n  padding-left: 16px;\n  padding-right: 16px;\n}\n\n.aims-chat-grid {\n  margin-left: 16px;\n  margin-right: 16px;\n}\n\n\n.chat-inner:focus-visible {\n  outline: 3px solid #2A7FB8;\n}\n\n.chat-input-wrapper {\n  border-top: 1px solid #ccc;\n  padding-top: 24px;\n  display: flex;\n}\n\n.ask-btn-wrapper {\n  /* border: 1px solid red; */\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  padding-bottom: 4px;\n  padding-left: 8px;\n  position: relative;\n  bottom: 15px;\n}\n\n.text-input-wrapper {\n  flex-grow: 1;\n  margin-right: 16px;\n}\n\n.aims-file-input {\n  display: none;\n}\n\n.vanilla-text-input {\n  width: 100%;\n  font-family: 'Inter';\n  padding: 5px;\n}\n\n.chat-bubble {\n  padding: 16px;\n  margin-bottom: 16px;\n}\n\n.chat-bubble--bot {\n  background: #e9f2f7;\n}\n\n.chat-bubble--human {\n  background: #f5f5f5;\n}\n\n.aims-followup {\n  margin-top: 16px;\n}\n\n.aims-followup-ul {\n  padding-left: 16px;\n  margin-top: 16px;\n}\n\n.aims-followup-li {\n  margin-bottom: 8px;\n}\n\n.aims-sources-ul {\n  padding-left: 16px;\n  margin-top: 16px;\n}\n\n.aims-sources-li {\n  margin-bottom: 8px;\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n}\n\n.aims-meeting-summary-ul {\n  padding-bottom: 24px;\n  border-bottom: 1px solid #E2E2E2;\n}\n\n.aims-meeting-summary-ul li {\n  list-style-type: disc;\n  margin-bottom: 16px;\n}\n\n.aims-chat-message {\n  margin-bottom: 16px;\n}\n\n.aims-upload-icon {\n  color: var(--color-interactive-primary-default);\n  background: none;\n  position: relative;\n  top: 4px;\n  font-size: 16px;\n  ;\n}\n\n.aims-upload-icon:hover {\n  color: var(--color-interactive-primary-hover);\n  background: none;\n}\n\n.campy-chat-area {\n  display: none;\n}\n\n/* loader */\n:root {\n  --loader-color: rgb(17, 115, 176);\n}\n\n.loader {\n  position: relative;\n  left: -9999px;\n  margin-left: 40px;\n  margin-bottom: 40px;\n  margin-top: 40px;\n  width: 10px;\n  height: 10px;\n  border-radius: 5px;\n  background-color: var(--loader-color);\n  color: var(--loader-color);\n  box-shadow: 9984px 0 0 0 var(--loader-color), 9999px 0 0 0 var(--loader-color), 10014px 0 0 0 var(--loader-color);\n  animation: dot-typing 1.5s infinite linear;\n}\n\n@keyframes dot-typing {\n  0% {\n    box-shadow: 9984px 0 0 0 var(--loader-color), 9999px 0 0 0 var(--loader-color), 10014px 0 0 0 var(--loader-color);\n  }\n\n  16.667% {\n    box-shadow: 9984px -10px 0 0 var(--loader-color), 9999px 0 0 0 var(--loader-color), 10014px 0 0 0 var(--loader-color);\n  }\n\n  33.333% {\n    box-shadow: 9984px 0 0 0 var(--loader-color), 9999px 0 0 0 var(--loader-color), 10014px 0 0 0 var(--loader-color);\n  }\n\n  50% {\n    box-shadow: 9984px 0 0 0 var(--loader-color), 9999px -10px 0 0 var(--loader-color), 10014px 0 0 0 var(--loader-color);\n  }\n\n  66.667% {\n    box-shadow: 9984px 0 0 0 var(--loader-color), 9999px 0 0 0 var(--loader-color), 10014px 0 0 0 var(--loader-color);\n  }\n\n  83.333% {\n    box-shadow: 9984px 0 0 0 var(--loader-color), 9999px 0 0 0 var(--loader-color), 10014px -10px 0 0 var(--loader-color);\n  }\n\n  100% {\n    box-shadow: 9984px 0 0 0 var(--loader-color), 9999px 0 0 0 var(--loader-color), 10014px 0 0 0 var(--loader-color);\n  }\n}\n\nul {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.color-interactive {\n  color: #1773b0;\n}\n\n.color-gray {\n  color: #666;\n}\n\nlabel {\n  color: #666;\n  font-size: 12px;\n  margin-bottom: 4px;\n}\n\nul {\n  padding: 0;\n}\n\nli {\n  list-style: none;\n}\n\n.aims-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
